<template>
  <div>
    <div class="vr_24">
    <search-bar theme="light" ajax="true" v-on:new-text-search="handleNewTextSearch($event, result)"></search-bar>
    </div>
    <div class="vr_12" v-if="searchString">
        <h1 class="hdg hdg_2"><span>Search results for: </span><span class="m-fontWeight_light m-font_default m-fontStyle_italic m-fontColor_blue m-fontSize_plus4">"{{searchString}}"</span></h1>
    </div>
    <div class="tabFilters">
        <div class="tabFilters-tabs tabFilter-tabs_withPagination">
            <div class="tabFilters-tabs-container">
                <ul class="tabFilters-tabs-container-list" >
                    <li v-for="(array, option) in categoryFilters" class="tabFilters-tabs-container-list-item" :key="option">
                        <template v-for="(item, index) in array">
                            <input type="radio" :name="option" :id="item.text" :value="item.value" :key="index + 'option'" v-model="currentFilter">
                            <label :for="item.text" :key="index + 'label'" >{{item.text}}</label>
                        </template>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <search-list
        :filter-options="categoryFilters"
        :items="items"
        :items-per-page="itemsPerPage"
        :itemTotal="itemTotal"
        :activeIndex="activeIndex"
        :pageToIndex="pageToIndex"
        class="m-positionRelative"
        >
        <template slot="list-display" slot-scope="props" >
            <transition name="v-fade" mode="out-in">
                <div v-if="!dataIsLoaded" class="loading loading_overlay"></div>
            </transition>
            <transition-group
                class="searchResults"
                tag="ul"
                name="v-fade"
                appear
                >
                <search-item v-for="(item,index) in props.items" :key="index" :item="item"></search-item>
                
            </transition-group>
        </template>
        <template slot="list-no-results">
            <div class="section_padding" v-if="dataIsLoaded">
                <div class="hdg_2 m-text_center" >There are no results for your search.</div>
            </div>
        </template>
    </search-list>

  </div>
</template>

<script>
import SearchBar from "../SearchBar/SearchBar.vue";
import TabFilters from "../templates/TabFilters.vue";
import SearchList from "../list/SearchList.vue";
import SearchItem from "../templates/SearchItem.vue";

import SearchService from "../../service/SearchService.js";

import { jsonToQueryString } from "../../utilities/jsonToQueryString";
import { getParams } from "../../utilities/getParams";

export default {
  props: {
    filterOptions: {
      required: true,
      type: Object
    },
    itemsPerPage: {
        type: Number
    }
  },
  data() {
    // set up initial data structure for queryParamsObject
    // NOTE: this needs to be fully fleshed out so vue can cache and observe correctly
    let data = {
        queryParamsObject: {
            q: '',
            filter: ''
        },
        items: [],
        searchFilter: null,
        activeIndex: 0,
        itemTotal: null,
        currentFilter: "",
        dataIsLoaded: false,
        categoryFilters: this.categoryFilters,
        fetching: false,
    };

    // copy in things from getParams()
    Object.assign(data.queryParamsObject, getParams(window.location));

    //check to make
    return data
  },
  computed: {
    searchString: {
      get() {
          return this.queryParamsObject.q;
      },
      set(value) {
        this.queryParamsObject.q = value;
      }
    }
  },
  created() {
    // if filters are not empty apply correct filter state
    if (this.queryParamsObject.filter) {
      this.currentFilter = this.queryParamsObject.filter;
    }

    this.getItems();
  },
  watch: {
    currentFilter() {
      this.performSearch();
    }
  },
  methods: {
    buildQueryObject() {
      return {
        q: this.searchString || '',
        filter: this.currentFilter
      };
    },
    handleNewTextSearch(result) {
      // set search string to update view
      this.searchString = result;

      this.performSearch();
    },
    performSearch() {
        this.activeIndex = 0;
      //adjust url
      this.changeUrl();

      // fetch results
      this.getItems();
    },
    changeUrl() {
      // set url to reflect query
      let baseURL =
        location.protocol + "//" + location.host + location.pathname;
        baseURL += jsonToQueryString(this.buildQueryObject());

      // set url params to allow for persistent searches
      window.history.replaceState("", "", baseURL);
    },
    pageToIndex(newIndex) {
        this.activeIndex = newIndex;
        this.getItems();
    },
    async getItems() {
      const queryObject = this.buildQueryObject();
      this.dataIsLoaded = false;
      this.response = await SearchService.getResults(queryObject, this.activeIndex, this.itemsPerPage);
      this.itemTotal = this.response.totalItems;
      this.categories = this._getCategoriesFromResponse(this.response.filterGroupItems),
      this.items = this.response.results;
      this.dataIsLoaded = true;
    },
    _getCategoriesFromResponse(CategoryObject) {
        if(CategoryObject !== undefined) {
            return this.categoryFilters = CategoryObject;
        }
    }
  },
  components: {
    SearchList,
    SearchBar,
    SearchItem,
    TabFilters,
  }
};
</script>

